import { cn } from "@-/com.npmjs.cn";
import { Pressable } from "@-/com.npmjs.react-native";
import {
  buttonTextVariants,
  buttonVariants,
  type ButtonProps,
} from "@-/dev.improve.haniverse.components.ui.button";
import { TextClassContext } from "@-/dev.improve.haniverse.components.ui.text";
import { GlassContentScope, ToolbarGlassSurface } from "#toolbar-glass-surface";

/** Glass action pill; keeps the button's layout, accessibility and pending-state contract. */
export function GlassButton({
  accessibilityRole = "button",
  accessible = true,
  children,
  className,
  isDisabled,
  isLoading,
  onPress,
  size,
  ...props
}: Omit<ButtonProps, "variant">) {
  return (
    <TextClassContext value={buttonTextVariants({ size, variant: "ghost" })}>
      <Pressable
        accessibilityRole={accessibilityRole}
        accessible={accessible}
        className={cn(
          buttonVariants({ size, variant: "link" }),
          "relative overflow-hidden rounded-full",
          (props.disabled || isDisabled) && "cursor-not-allowed opacity-50",
          className,
        )}
        onPress={isLoading || isDisabled ? undefined : onPress}
        role="button"
        {...props}
      >
        {(state) => (
          // The label sits beside the glass, not in it, so both share one scope.
          <GlassContentScope>
            <ToolbarGlassSurface
              className="absolute inset-0"
              interactive={false}
              pointerEvents="none"
              selected={state.pressed}
            />
            {typeof children === "function" ? children(state) : children}
          </GlassContentScope>
        )}
      </Pressable>
    </TextClassContext>
  );
}
